import React from "react";
import styles from "./searchBar.module.scss"
import {ReactComponent as SearchIcon} from "../../assets/promos&items/search_icon.svg";
import {ReactComponent as SearchFilterIcon} from "../../assets/promos&items/search_filter_icon.svg";
import {ReactComponent as SearchClearIcon} from "../../assets/promos&items/search_clear_icon.svg";

interface Props {
    onSearchEnteredTerm?: (e: any) => void;
    clearSearch?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onChangeSearchValue?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    searchValue?: string
}


export const SearchBar = (props: Props) => {
    return (
        <form action="" onSubmit={props.onSearchEnteredTerm} className={styles.search_bar_form}>
            <div className={styles.search_bar_wrapper}>
                <div className={`${styles.search_icon} ${styles.icons}`} onClick={props.onSearchEnteredTerm}>
                    <SearchIcon/>
                </div>
                <div className={`${styles.search_filter_icon} ${styles.icons}`}>
                    <SearchFilterIcon/>
                </div>
                <div className={`${styles.search_clear_icon} ${styles.icons}`} onClick={props.clearSearch}>
                    <SearchClearIcon/>
                </div>
                <input type="text" placeholder={`Please enter search term`} onChange={props.onChangeSearchValue}
                       value={props.searchValue}/>
            </div>
        </form>

    )
}